const DarkModeMoon = ({ color }) => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.05028 12C6.90741 12 7.73932 11.825 8.52082 11.4786C8.81973 11.3464 9.007 11.0464 8.9998 10.7214C8.98899 10.4 8.78372 10.1143 8.4776 10C7.48002 9.62857 6.6301 8.975 6.01427 8.11071C5.38403 7.22857 5.05271 6.18571 5.05271 5.1C5.05271 3.68571 5.61452 2.36071 6.6337 1.36786C6.86419 1.13929 6.93622 0.796428 6.81377 0.496428C6.69133 0.2 6.39962 0.00357143 6.07549 0H6.05028C4.43327 0 2.9135 0.625 1.77187 1.75714C0.630238 2.88929 0 4.39643 0 6C0 7.60357 0.630238 9.11071 1.77187 10.2429C2.9135 11.375 4.43327 12 6.05028 12Z"
        fill="#737373"
      />
    </svg>
  );
};

export default DarkModeMoon;
